export default {
    COMMON: {
        SITE: "Estabelecimento | Estabelecimento",
        SILO: "Silo | Silos",
        SECTION: "Seção | Seções",
        DESCRIPTION: "Descrição",
        TEMPERATURE: "Temperatura",
        HUMIDITY: "Umedade",
        MOISTURE: "Umidade dos grãos",
        MOISTABLE: "Umidade",
        CO2: "CO2",
        SAVE: "Salvar",
        CANCEL: "Cancelar",
        LAST_SYNC: "Última medição",
        SAVE_SUCCESS: "Salvar com sucesso",
        SAVE_FAILURE: "Ups.. parece que houve um erro",
        NO_DATA: "Não há dados",
        BACK_DASHBOARD: "Voltar para Dashboard",
        CLICK_SILO: "Clique duas vezes para ver detalhes do silo ",
        STATUS: "Status",
        SILO_DETAILS: "Ver detalhes",
        CLOSE: "Fechar"
    },
    GRAIN: {
        SOJA: "Soja",
        MAIZ: "Milho",
        CEBADA: "Cevada",
        TRIGO: "Trigo",
        GIRASOL: "Girassol",
        CENTENO: "Centeio",
        POROTO: "Feijao",
        ARROZ: "Arroz"
    },
    SIDEBAR: {
        HISTORICS: "Histórico",
        METRICS: "Métricas",
        CONFIGS: "Configurações",
        DAILY_REPORT: "Dados mais recentes",
        DASHBOARD: "Dashboard",
        ANALYTICS: "Analítca",
        RISK_ANALYSIS: "Análise de risco",
        //INSURANCE: "Cotiza tu Seguro"
        INSURANCE: "Seguro"
    },
    LOGIN: {
        USERNAME: "Usuário",
        USERNAME_REQUIRED: "Por favor preencha o nome de usuário",
        PASSWORD_REQUIRED: "Por favor complete a senha",
        PASSWORD: "Senha",
        WELCOME: "¡Bem Vindo!",
        SIGN_IN: "Entrar"
    },
    NAVBAR: {
        PROFILE: "Perfil",
        LOGOUT: "Fechar Sessão",
        ADMIN: "Administrador",
    },
    MONITOR: {
        WARNING_DETAILS: "Detalhe de alerta",
        SILO_DATA: "Dados do silo"
    },
    PROFILE: {
        CELSIUS: "Graus Celcius [C°]",
        FAHRENHEITS: "Graus Fahrenheits [F]",
        PPM: "Partes por milhão [ppm]",
        PERCENTAGE: "Percentual [%]",
        USER_DATA: "Dados do usuário",
        USER_PROFILE: "Dados do usuário",
        UNITS_DEFAULT: "Unidades padrão",
        NAME: "Nome",
        LAST_NAME: "Sobrenome",
        CONTACT_PHONE: "Telefone de contacto",
        EMAIL: "Email",
        UNITS: "Unidades",
        CHANGE_PASSWORD: "Alterar Senha",
        NEW_PASSWORD: "Alterar Senha",
        FILL_NEW_PASSWORD: "Digite a nova senha",
        LOGOUT: "Fechar Sessão",
        LOGOUT_MESSAGE: "Para que as alterações entrem em vigor, é necessário fazer login novamente",
        CONF_CHANGE: "Alteração de configuração",
        SILO_DETAIL_ENABLE: "Detalhe do silo ativado",
        SILO_DETAIL_DISABLE: "Detalhe do silo desativado",
        SILO_DETAIL: "Detalhe do Silo",
        CONTINUE: "Continuar",
        TIMEZONE: "Fuso horário",
        CONFIRM_PASSWORD: "Reingrese su Contraseña",
        FILL_CONFIRM_PASSWORD: "Por favor reingrese su contraseña",
        MAX_LENGTH_EXCEEDED: "A senha não pode ter mais de 44 caracteres",
        PASSWORDS_DO_NOT_MATCH: "As senhas não coincidem",
        PASSWORD_CHANGE_CANCELLED: "Alteração de senha cancelada",
        EDIT_MESSAGE: "Para editar seu perfil, utilize o novo site. Qualquer dúvida, entre em contato com Wiagro"

    },
    RISK_ANALYSIS: {
        TITLE: "Análise de risco",
        NO_SECTIONS: "Este silo não possui sensores associados",
        LOW: "Baixo",
        MEDIUM: "Médio",
        HIGH: "Alto",
        VERY_HIGH: "Muito alto"
    },
    CONFIGS: {
        CONFIGS: "Configurações",
        SUBTITLE: "Selecione as unidades mínima e máxima para cada limite"
    },
    ERROR: {
        1: "Versão da interface não indicada",
        2: "Um comando não foi especificado",
        3: "Faltam parâmetros necessários para o comando especificado",
        4: "Comando incorreto",
        5: "Ups .. ocorreu um erro",
        6: "O método http está incorreto para o comando",
        7: "A versão da interface especificada não foi verificada",
        8: "O comando está declarado, mas o serviço ainda não está envolvido",
        9: "Nome de usuário ou senha inválidos",
        10: "Sessão expirada",
        11: "Parâmetro incorreto na solicitação",
        12: "O número de sessões simultâneas foi excedido",
        13: "O estabelecimento não pertence ao usuário",
        14: "Não há sessão para o usuário",
        15: "O estabelecimento não possui silo associado",
        16: "O silo não foi encontrado para o estabelecimento indicado",
        COMMUNICATION_FAILURE: 'Falha na comunicação',
        OUTDATED: 'Desatualizado'

  },
    REPORTS: {
        DAILY_REPORT: "Relatório diário",
        NO_SECTIONS: "Este silo não possui sensores associados",
        NO_DATA: "S/D",
        NO_DATA_FOR_DATE_AND_SILO: "Não há medidas para {silo} e a data selecionada",
        PICK_A_DATE: "Selecione uma data",
        LAST_DATA: "Dados mais recentes",
        STATUS_COLOR: "Cor de status",
        BAGGED_DATE:"Data ensacada: ",
        INI_MOISTURE: "Umidade inicial: ",
        TONS: "Toneladas: ",
        SILO_DATA: "Dados do silo",
        SILO_DETAILS: "Detalhes do silo",
        SENSOR_FAIL: "Falha do sensor",
    },
    HISTORICS: {
        HISTORICS: "Histórico",
        DATE_FROM: "De",
        DATE_TO: "Até",
        NO_SITES: "Você ainda não tem nenhum estabelecimento criado",
        SILO_WITH_NO_SENSORS: "Este silo não possui sensores",
        PICK_A_DATE: "Selecione uma data",
        NO_DATA_FOR_THIS_DATE: "Não há dados para a data selecionada",
        SECTION_NAME: "Seção {section}"

    },
    STATUS: {
        NO_DATA: "Sem dados",
        OK: "Ok",
        WARN: "Medição fora da faixa estabelecida",
        ERROR: "Medição em faixas críticas",
        DISABLED: "Desativado"

    },
    INDICATOR: {
        OK: "Ok",
        DANGER: "Perigo",
        WARN: "Alerta",
        NO_DATA: "Sem dados",
    },
    EVENTS: {
        MOV: "Alerta de movimiento",
        STAT_TEMP: "Alerta de temperatura",
        STAT_CO2: "Alerta de CO2",
        STAT_HUM: "Alerta de umidade",
        STAT_HUM_GRANO: "Alerta de umedade dos grãos",
        NO_EVENTS: "Não há alertas",
        BREAK_BAG: "Possível quebra de saco",
        AVERY_BAG: "Possível abertura do saco",
        HUM_ALERT: "Alerta de humidade"        

    },  

    el:{
        select:{
            noData: "Sem dados",
            placeholder: "Selecione uma opção"
        },
        table:{
            confirmFilter: "Confirmar",
            resetFilter: "Apagar"
        },
        datepicker:{
            now: "Agora",
            today: "Hoje",
            cancel: "Cancelar",
            clear: "Clara",
            confirm: "Confirmar",
            selectDate: "Selecione data",
            selectTime: "Selecione hora",
            startDate: "Data de início",
            startTime: "Hora de início",
            endDate: "Data Final",
            endTime: "Hora Final",
            prevYear: "Ano Anterior",
            nextYear: "Próximo Ano",
            prevMonth: "Mês Anterior",
            nextMonth: "Próximo Mês",
            year: "",
            month1: "Janeiro",
            month2: "Fevereiro",
            month3: "Marchar",
            month4: "Abril",
            month5: "Pode",
            month6: "Junho",
            month7: "Julho",
            month8: "Agosto",
            month9: "Setembro",
            month10: "Outubro",
            month11: "Novembro",
            month12: "Dezembro",
            month: 'Mês',
            week: 'Semana',
            weeks: {
                sun: 'D',
                mon: 'L',
                tue: 'M',
                wed: 'M',
                thu: 'J',
                fri: 'V',
                sat: 'S'
            },
            months: {
                jan: 'Jan',
                feb: 'Fev',
                mar: 'Mar',
                apr: 'Abr',
                may: 'maio',
                jun: 'Jun',
                jul: 'Jul',
                aug: 'Ago',
                sep: 'Set',
                oct: 'Out',
                nov: 'Nov',
                dec: 'Dez'
            }
        }
    }
};